__turbopack_context__.v({
  "borderRoot": "AnimatedGradientBorder-module__5v3ywW__borderRoot",
  "pl-plan-gradient-rotate": "AnimatedGradientBorder-module__5v3ywW__pl-plan-gradient-rotate",
});
